function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "files",
  transform: "translate(0.046 0.05)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M5.56,26.031c-.19-.1.155.225-5.281-5.3-.373-.38-.265.785-.265-18.136A2.575,2.575,0,0,1,2.565,0H17.083a2.575,2.575,0,0,1,2.55,2.593V23.534a2.575,2.575,0,0,1-2.55,2.594c-4.486,0-7.19.006-8.832.006C5.5,26.134,5.73,26.117,5.56,26.031Zm18.987-.821a.91.91,0,0,1,.9-.918.752.752,0,0,0,.744-.758V2.593a.751.751,0,0,0-.744-.757.911.911,0,0,1-.9-.918A.911.911,0,0,1,25.45,0,2.575,2.575,0,0,1,28,2.593V23.534a2.575,2.575,0,0,1-2.55,2.594A.911.911,0,0,1,24.548,25.21Zm-4.184,0a.91.91,0,0,1,.9-.918.753.753,0,0,0,.745-.758V2.593a.752.752,0,0,0-.745-.757.911.911,0,0,1-.9-.918.911.911,0,0,1,.9-.918,2.575,2.575,0,0,1,2.551,2.593V23.534a2.575,2.575,0,0,1-2.551,2.594A.911.911,0,0,1,20.363,25.21Z",
  transform: "translate(0 0)",
  fill: "#ff4f5a",
  stroke: "#ff4f5a",
  strokeMiterlimit: 10,
  strokeWidth: 0.1
}));

function SvgScreens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.096,
    height: 26.234,
    viewBox: "0 0 28.096 26.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreens);
export default __webpack_public_path__ + "static/media/screens.3dd6cbef.svg";
export { ForwardRef as ReactComponent };